export const defaultState = {
  knowledgeDomains: [],
  knowledgeSubDomains: [],
  psychometricLanguages: [],
  positionPsychometricLanguages: [],
  positionKnowledgeSubDomains: [],

  questionBankQuestions: [],
  questionBankKnowledgeDomains: [],

  knowledgeLevels: [],

  tempPSYQuestions: [],

  activeCandidates: [],
  applicantSessionLogs: [],

  dashboardChartsData: {},

  requisitionPsychometricLanguages: [],
  requisitionKnowledgeSubDomains: [],

  questionLogs: [],
};
